interface SvgInterface {
    className?: string;
    onClick?: () => void;
}
export function EditIcon({className = '', onClick = () => {}}: SvgInterface) {
    return <svg className={className} onClick={onClick} enableBackground="new 0 0 32 32" height="32px" id="svg2" version="1.1" viewBox="0 0 32 32" width="32px"><g id="background"><rect fill="none" height="32" width="32"/></g><g id="edit"><polygon points="10,28 4,28 4,22  "/><rect height="8.485" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 41.6274 8.7574)" width="28.284" x="4.858" y="8.757"/><polygon points="4,32 4,30 26,30 26,32 4,32  "/></g></svg>;
}